var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    margin: '0 auto',
    position: 'relative',
    width: _vm.scaledCropWidth + 'px',
    height: _vm.scaledCropHeight + 'px',
    overflow: 'hidden'
  })},[_c('div',{style:({
      position: 'absolute',
      left: -_vm.scaledCropX + 'px',
      top: -_vm.scaledCropY + 'px',
      width: _vm.scaledWidth + 'px',
      height: _vm.scaledHeight + 'px'
    })},[_c('edit-player',{ref:"editPlayer",attrs:{"player-data":_vm.value,"mode":_vm.statusMode,"src":_vm.src,"thumbnail":_vm.thumbnail,"is-muted":_vm.isMuted,"video-sizes":_vm.videoSizes,"crop-video-resize":_vm.cropVideoResize,"player-time":_vm.playerTime,"player-start-time":_vm.playerStartTime,"paused":_vm.paused,"original-size":true,"hide-controls":true},on:{"update:isMuted":function($event){_vm.isMuted=$event},"update:is-muted":function($event){_vm.isMuted=$event},"timeUpdate":function($event){return _vm.$emit('timeUpdate', $event)},"updatePausedTrue":_vm.updatePauseTrue,"updatePausedFalse":_vm.updatePauseFalse,"playerDataChanged":_vm.playerDataChanged}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }